<template>
    <a-card>
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                <a-icon type="percentage" />
            </a-col>
            <a-col :flex="3" justify="center">
                <p>Progress</p>
            </a-col> 
        </a-row>

        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="3" justify="center">
                <a-progress :percent="progress" size="small" status="active" />   
            </a-col> 
        </a-row>
      
        <br/>
    </a-card>
</template>

<script>
export default {
    props : {
        progress : Number 
    },
}
</script>
